import React from 'react'
import config from '../../../config/index'
import { APIProvider } from '@vis.gl/react-google-maps'

export const ApiProvider = ({ children }) => {
  return (
    <APIProvider
      apiKey={`${config.GOOGLE_KEY}`}
      libraries={['places']}
    >
      {children}
    
    </APIProvider>
  )
}
